type FileListItem = {
  file_type?: unknown
  file?: {
    originFileObj?: unknown
  }
  originFileObj?: unknown
}

type DataWithFileList = {
  file_list?: FileListItem[] | null
}

export const createFormDataNested = (
  data: unknown,
  file_key?: string | null
) => {
  const formData = new FormData()

  const isFile = (value: unknown): value is File | Blob => {
    return value instanceof File || value instanceof Blob
  }

  const appendToFormData = (
    key: string | number,
    value: unknown,
    parentKey = ""
  ) => {
    const fullKey = parentKey ? `${parentKey}.${key}` : `${key}`

    if (key === "file_list" || value == null) return

    if (isFile(value)) {
      formData.append(fullKey, value)
      return
    }

    const valueWithOriginFileObj = value as { originFileObj?: unknown }

    if (
      valueWithOriginFileObj?.originFileObj &&
      isFile(valueWithOriginFileObj.originFileObj)
    ) {
      formData.append(fullKey, valueWithOriginFileObj.originFileObj)
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item !== null && typeof item === "object") {
          // Recursive handling of objects in arrays
          if (
            isFile(item) ||
            (item as { originFileObj?: unknown })?.originFileObj
          ) {
            appendToFormData(index, item, fullKey)
          } else {
            Object.entries(item).forEach(([nestedKey, nestedValue]) => {
              appendToFormData(nestedKey, nestedValue, `${fullKey}[${index}]`)
            })
          }
        } else {
          formData.append(`${fullKey}[${index}]`, item as string | Blob)
        }
      })
      return
    }

    if (typeof value === "object" && value.constructor === Object) {
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        appendToFormData(nestedKey, nestedValue, fullKey)
      })
      return
    }

    formData.append(fullKey, value as string | Blob)
  }

  Object.entries(data as object).forEach(([key, value]) => {
    appendToFormData(key, value)
  })

  const dataWithFileList = data as DataWithFileList

  if (dataWithFileList.file_list) {
    dataWithFileList.file_list.forEach((file, index) => {
      if (file?.file_type) {
        formData.append(
          `${file_key || "files"}[${index}].file`,
          (file as { file: { originFileObj: Blob | File } }).file.originFileObj
        )
        formData.append(
          `${file_key || "files"}[${index}].file_type`,
          file?.file_type as string | Blob
        )
      } else {
        formData.append(file_key || "files", file.originFileObj as Blob | File)
      }
    })
  }

  return formData
}
